<template>
  <el-dialog title='补录合同' :visible.sync='contractVisible' :close-on-click-modal='false'
             append-to-body width='910px' @close="cancel">
    <div-border label='价格设置'>
      <div class='nav' style="margin-top: 10px">
        <div class='navContainer' style="width: 300px">
          <p style="width: 100px">不含税金额：</p>
          <el-input v-model.number='condition.price' size='mini' style='width:150px'
                    placeholder='请输入不含税金额' />
        </div>
        <div class='navContainer'>
          <p>含税金额：</p>
          <el-input v-model.number='condition.taxPrice' size='mini' style='width:150px'
                    placeholder='请输入含税金额' />
        </div>
        <div class='navBtn'>
          <el-button size='small' class='searchBtn' @click='contractConfirm'>确定</el-button>
          <el-button size='small' class='resetBtn' @click='cancel'>取消</el-button>
        </div>
      </div>
    </div-border>
    <div-border label='选择合同'>
      <el-table :data='contractTableData' highlight-current-row border ref='contractTable'
                @current-change='contractChange' v-loading='contractLoad' style="margin-top: 10px"
                :header-cell-style="{color:'#3B3B3B','font-weight':'700','padding':'0px','font-size':'13px',height:'35px',background:'#E8E8E8',}"
                :cell-style="{ color:'#7F7F7F','font-size':'13px' }">
        <el-table-column type='index' width='50' />
        <el-table-column property='codeNumber' label='合同编号' min-width='150' align='center' />
        <el-table-column property='contractName' label='合同名称' min-width='150' align='center' />
        <el-table-column property='typeName' label='合同类型' min-width='100' align='center' />
        <el-table-column property='companyName' label='签约单位' min-width='150' align='center' />
        <el-table-column property='startDate' label='开始日期' min-width='100' :formatter='getDate'
                         align='center' />
        <el-table-column property='endDate' label='结束日期' min-width='100' :formatter='getDate'
                         align='center' />
      </el-table>
      <div style='margin-top: 20px'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='addContractSizeChange'
          @current-change='addContractCurrentChange'
          :current-page.sync='page'
          :page-size='row'
        />
      </div>
    </div-border>
  </el-dialog>
</template>
<script>
import {addContract, getContractPageList} from "@/service/financial";
import divBorder from "@/components/divBorder.vue";

export default {
  components: {divBorder},
  data(){
    return{
      contractVisible: false,
      contractTableData: [],
      condition: {
        price:'',
        taxPrice: '',
        priceInfoId: '',
        rate: ''
      },
      contractLoad: false,
      //总数据条数
      total: 0,
      //当前页数
      page: 1,
      //每页显示多少条数据
      row: 10,
      selectContract: {
        id: '',
        codeNumber: '',
        companyName: '',
        startDate: '',
        endDate: '',
      },
    }
  },
  methods: {
    dialogOpen(row) {
      this.condition.id = row.id
      this.companyId = row.customerId
      this.condition.rate = row.taxRate
      this.contractPrice = row.contractPrice
      this.preparePrice = row.preparePrice
      this.startDate = row.startDate
      this.endDate = row.endDate
      this.selectContract = '';
      this.getContractPageList()
    },
    //查询
    async getContractPageList() {
      let obj = {
        id: this.condition.id,
        companyId: this.companyId,
        rate: this.condition.rate,
        contractPrice: this.contractPrice ? this.contractPrice : '',
        preparePrice:  this.preparePrice ? this.preparePrice : '',
        page: this.page,
        row: this.row,
      };
      this.contractLoad = true;
      let res = await getContractPageList(obj);
      this.contractLoad = false;
      if (res.status !== 0) {
        this.$message.error(res.message)
        this.contractVisible = false
      }else {
        this.contractVisible = true
        this.contractTableData = res.data.records;
        this.total = res.data.total
      }
    },
    //确认
    async contractConfirm(){
      if (!this.condition.price || this.condition.price === '') {
        return this.$message.warning('请输入不含税金额！');
      }
      if (!this.condition.taxPrice || this.condition.taxPrice === '') {
        return this.$message.warning('请输入含税金额！');
      }
      if (!this.selectContract.id || this.selectContract.id === '') {
        return this.$message.warning('请选择合同！');
      }
      let obj = {
        type: 2,
        rate: this.condition.rate,
        taxPrice: this.condition.taxPrice,
        price: this.condition.price,
        priceInfoId: this.condition.id,
        contractId: this.selectContract.id,
        startDate: this.startDate,
        endDate: this.endDate
      };
      const res = await addContract(obj)
      if(res.status !== 0)return this.$message.error((res.message))
      this.$message.success(res.message);
      this.contractVisible = false
    },
    //取消
    cancel(){
      this.condition.price = ''
      this.condition.taxPrice = ''
      this.contractVisible = false
    },
    addContractSizeChange(rows) {
      this.row = rows;
      this.getContractPageList();
    },
    addContractCurrentChange(page) {
      this.page = page;
      this.getContractPageList();
    },
    // 时间长度处理
    getDate(row, column, cellValue) {
      if (cellValue) {
        return cellValue.substring(0, 10);
      } else {
        return '';
      }
    },
    // 合同编号 —— 选中数据
    contractChange(val) {
      this.selectContract = val;
    },
  }
}
</script>


<style scoped lang="scss">
.navBtn {
  display: inline-block;
  width: calc(100% - 690px);
  text-align: right;
  margin-bottom: 10px;
}

.navContainer {
  display: inline-block;
  width: 230px;
  text-align: center;

  p {
    display: inline-block;
    width: 70px;
  }
}
::v-deep {
  .transportTitle {
    z-index: 99;
  }

  .el-table__body tr.current-row > td {
    background-color: #409eff;
    color: #fff !important;
  }

  .cell .el-form-item {
    padding: 0 2px;
  }

  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
    text-align: center;
  }

  .el-dialog__headerbtn {
    top: 0px;
    height: 42px;
    line-height: 42px;
    right: 10px;
    font-size: 20px;

    .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
  }

  .el-dialog__title {
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }

  .el-dialog__body {
    padding: 20px !important;
    max-height: 60vh;
    overflow-y: auto;
  }
}
</style>
